import { SharedAngular } from '@Client/@types/sharedAngular';
import angular, { IComponentController } from 'angular';

class ProcessMapTabStepFormController implements IComponentController {
  static $inject = ['fileService', 'sessionService'];

  selectedNode: any;

  constructor(
    private fileService: SharedAngular.FileService,
    private sessionService: SharedAngular.SessionService
  ) {}

  public $onChanges() {
    if (this.selectedNode) {
      this.formatFields(this.selectedNode);
    }
  }

  private formatFields(selnode) {
    selnode.fields?.forEach((field) => {
      if (field.type === 'attachdocument') {
        field.attachDocuments.forEach((attachment) => {
          attachment.downloadLink = this.fileService.getDownloadLink(
            attachment.fileId,
            !this.sessionService.isAuthenticated()
          );
        });
      }
    });
  }
}

export class ProcessMapTabStepForm implements angular.IComponentOptions {
  public bindings: Bindings;
  public templateUrl: string;

  constructor() {
    this.bindings = {
      selectedNode: '<'
    };

    this.templateUrl =
      'Client/runner.processmapsv2/components/View/RightPanel/StepForm/runner.processmap.tab.step-form.tmpl.html';
  }

  controller = ProcessMapTabStepFormController;
}

angular
  .module('flowingly.runner.processmapsv2')
  .component('processmapTabStepForm', new ProcessMapTabStepForm());
